import React from "react";
import _ from "lodash";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedList from "components/atoms/ThemedList";
import i18n from "utils/i18n";
import Text from "theme/Text";
import ThemedBlockTitle from 'components/atoms/ThemedBlockTitle'
import { StyleSheet, View } from 'react-native'
import { textStyles } from 'styles/text'
import HelperString from 'utils/helper-string'
import LoadingComponent from 'components/atoms/Loading'


const ManagementGroupedThemeList = ({ items, renderItem, groupByKey, groupByValues = [], filters, header, isSearching = false }) => {

	const contentList = [];

	if( _.size( groupByValues ) === 0 ) {
		for ( let item of items ) {
			if ( groupByValues.includes( item[ groupByKey ] ) === false ) {
				groupByValues.push( item[ groupByKey ] );
			}
		}
		
		groupByValues.sort();
	}
	
	_.forEach( groupByValues, groupByValue => {
		const results = _.filter( items, item => {
			// if this is not where it should be grouped skipp other filters
			if( item[ groupByKey ] !== groupByValue ) {
				return false;
			}
			
			let truthy = true;
			if( filters ) {
				for( let filter of filters ) {
					let filterTruthy = false;
					
					const filterValue = filter.value?.toLowerCase();
					const itemField = _.get( item, filter.field, '' ).toLowerCase();

					switch( filter.kind ) {
						case 'contains':
							filterTruthy = itemField?.toLowerCase().indexOf( filterValue ) > -1;
							break;
							
						case 'equals':
							filterTruthy = itemField == filterValue;
							break;
					}

					if( filterTruthy === false ) {
						truthy = false;
						break;
					}
				}
			}
			
			return truthy;
		});

		if( _.size( results ) > 0 ) {
			if( _.size( contentList ) > 0 ) {
				contentList.push(
					<ThemedBlockTitle
						key={ HelperString.hash( 'ManagementGroupedThemeList-empty', groupByValue )}>
						
						{/*	Nothing */}
					</ThemedBlockTitle>
				)
			}
			
			contentList.push(
				<ThemedList
					key={ HelperString.hash( 'ManagementGroupedThemeList-data', groupByValue )}
					style={ staticStyles.themedListPaddingHorizontal0 }
					data={ results }
					renderItem={ renderItem }
				/>
			)
		}
	})
	
	return (
		<ThemedBlock
			header={ header }
			shadow>
			
			<View>
				<Choose>
					<When condition={ isSearching }>
						<LoadingComponent />
					</When>
					<When condition={ _.size( contentList ) > 0 }>
						<ThemedList
							style={ staticStyles.themedListPaddingHorizontal0 }
							data={ contentList }
							dividerEnabled={ false }
							renderItem={ ( { item } ) => {
								return item;
							}}
						/>
					</When>
					<Otherwise>
						<ThemedBlock transparent mediumPadding>
							<Text style={ textStyles.textCenter }>
								{ i18n.t( 'management:generic.no_results' ) }
							</Text>
						</ThemedBlock>
					</Otherwise>
				</Choose>
			</View>
		</ThemedBlock>
	)
}

const staticStyles = StyleSheet.create({
	themedListPaddingHorizontal0: {
		paddingHorizontal: 0,
	},
});

export default ManagementGroupedThemeList;
